export default {
  GET_SALES_CONSULTANTS: (state) => state.sales_consultants,
  GET_SALES_CONSULTANT: (state) => state.sales_consultant,
};
